define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FacilityDocTypeDomain = void 0;
    class FacilityDocTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: FacilityDocTypeDomain.Photo, value: "Photo" },
                    { key: FacilityDocTypeDomain.Other, value: "Other" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[FacilityDocTypeDomain.Photo] = 0;
                this.KeyIndex[FacilityDocTypeDomain.Other] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Photo"] = 0;
                this.ValueIndex["Other"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.FacilityDocTypeDomain = FacilityDocTypeDomain;
    Object.defineProperty(FacilityDocTypeDomain, "Photo", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(FacilityDocTypeDomain, "Other", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(FacilityDocTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
